export const LOGOUT = "LOGOUT";
export const CHECK_LOGIN = "CHECK_LOGIN";

export interface Logout {
    type: typeof LOGOUT;
}

export interface CheckLogin {
    type: typeof CHECK_LOGIN;
}

export type AuthenticationTypes = Logout | CheckLogin;
